import { MakeFederationAdminRequestRequest, MakeJudgeAdminRequestRequest, UserRequest } from '~/apis/ssf';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateUserMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.usersCreate,
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}

export function useUpdateUserMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: UserRequest }) => SSF.api.usersUpdate(id, payload),
    onSuccess: ({ data }) => {
      client.invalidateQueries({ queryKey: keys.detail(data.id) });
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}

export function useDeleteUserMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.usersDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useSetFederationAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: MakeFederationAdminRequestRequest) => SSF.api.usersSetFederationAdminCreate(payload),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.details() });
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}

export function useSetJudgeAdminMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: MakeJudgeAdminRequestRequest) => SSF.api.usersSetJudgeAdminCreate(payload),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: keys.details() });
      client.invalidateQueries({ queryKey: keys.lists() });
    },
  });
}
